const NewLineItemAction = Object.freeze({
	NEW: "new",
	EDIT: "edit",
	DUP: "duplicate",
});
let NewLineItemActionMixin = {
	data() {
		return {
			newLineItemAction: NewLineItemAction,
		}
	}
}
export default NewLineItemActionMixin